/**
 * Navegación: menú móvil accesible + resaltado de la sección activa.
 */

const SELECTORS = {
  nav: '[data-nav]',
  toggle: '[data-nav-toggle]',
  list: '[data-nav-list]',
  link: '[data-nav-link]',
  header: '[data-header]',
};

/* ---- Menú móvil --------------------------------------------------------- */

function initMobileMenu() {
  const nav = document.querySelector(SELECTORS.nav);
  const toggle = document.querySelector(SELECTORS.toggle);
  if (!nav || !toggle) return;

  const close = () => {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-locked');
  };

  const open = () => {
    nav.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-locked');
  };

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    isOpen ? close() : open();
  });

  // Al elegir un destino el menú se cierra solo.
  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) {
      close();
      toggle.focus();
    }
  });

  // Si el viewport crece hasta desktop, el estado móvil deja de aplicar.
  window.matchMedia('(min-width: 901px)').addEventListener('change', (e) => {
    if (e.matches) close();
  });
}

/* ---- Header compacto al scrollear --------------------------------------- */

function initHeaderState() {
  const header = document.querySelector(SELECTORS.header);
  if (!header) return;

  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
  document.body.prepend(sentinel);

  // IntersectionObserver en vez de un handler de scroll: no corre en cada
  // frame y no obliga al navegador a recalcular layout.
  const io = new IntersectionObserver(
    ([entry]) => header.classList.toggle('is-scrolled', !entry.isIntersecting),
    { rootMargin: '-40px 0px 0px 0px' }
  );
  io.observe(sentinel);
}

/* ---- Sección activa en el menú ------------------------------------------ */

function initScrollSpy() {
  const links = Array.from(document.querySelectorAll(SELECTORS.link));
  if (!links.length) return;

  const byId = new Map();
  const sections = [];

  links.forEach((link) => {
    const id = link.getAttribute('href')?.replace('#', '');
    const section = id && document.getElementById(id);
    if (!section) return;
    byId.set(section, link);
    sections.push(section);
  });

  if (!sections.length) return;

  const setActive = (section) => {
    links.forEach((l) => {
      l.classList.remove('is-active');
      l.removeAttribute('aria-current');
    });
    const link = byId.get(section);
    if (link) {
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'true');
    }
  };

  const visible = new Set();

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target);
      });
      if (!visible.size) return;
      // Con varias secciones a la vista gana la que está más arriba.
      const top = [...visible].sort(
        (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top
      )[0];
      setActive(top);
    },
    { rootMargin: '-45% 0px -45% 0px' }
  );

  sections.forEach((s) => io.observe(s));
}

export function init() {
  initMobileMenu();
  initHeaderState();
  initScrollSpy();
}
